import React from "react";
import "./Footer.css";
import logo from "../assets/logo.png";

export default function Footer() {
    return (
        <footer className="site-footer" role="contentinfo">
            <div className="footer-inner">
                <div className="col brand">
                    <img src={logo} alt="Nierówno Pod Sufitem" />
                </div>

                <div className="col hours">
                    <h4>Godziny Otwarcia</h4>
                    <p>Poniedziałek – Piątek: 11:00 – 16:00</p>
                    <p>Sobota – Niedziela: imprezy, cateringi</p>
                </div>

                {/* Uwaga: .contact-info, żeby nie kolidowało z .contact z Home */}
                <div className="col contact-info">
                    <h4>Kontakt</h4>
                    <p>
                        Telefon:{" "}
                        <a href="tel:+48523077755" aria-label="Zadzwoń pod numer +48 52 30 777 55">
                            +48 52 30 777 55
                        </a>
                    </p>
                    <p>
                        E-mail:{" "}
                        <a href="mailto:kontakt@nierownopodsufitem.pl">
                            kontakt@nierownopodsufitem.pl
                        </a>
                    </p>
                    <p>
                        Dworcowa 31
                        <br />
                        88-110 Inowrocław
                    </p>
                </div>
            </div>

            <div className="footer-bottom">
                <span>© {new Date().getFullYear()} Nierówno Pod Sufitem</span>
            </div>
        </footer>
    );
}
